import { MetaData } from "~/types/common";

export enum Role {
  ADMIN = "ADMIN",
  SUPER_ADMIN = "SUPER_ADMIN",
  LEAD = "LEAD",
  STAFF = "STAFF",
  CLIENT = "CLIENT",
}

export enum DriverType {
  ALL = "ALL",
  NONE = "NONE",
}

export enum InventoryStatusCode {
  NO_POSSESSION = "NO_POSSESSION",
  AVAILABLE_LIVE = "AVAILABLE_LIVE",
  AVAILABLE_ON_HAND = "AVAILABLE_ON_HAND",
  RELEASED = "RELEASED",
}

export enum BookingStatus {
  PENDING = "PENDING",
  CONFIRMED = "CONFIRMED",
  COMPLETED = "COMPLETED",
  CANCELED = "CANCELED",
}

export enum ClientType {
  GALLERY = "GALLERY",
  COLLECTOR = "COLLECTOR",
  ADVISOR = "ADVISOR",
  EXHIBITION = "EXHIBITION",
  SHIPPER = "SHIPPER",
  ARTIST = "ARTIST",
  PRODUCER = "PRODUCER",
  INTERIOR_DESIGNER = "INTERIOR_DESIGNER",
  OTHER = "OTHER",
}

export enum PackingTypes {
  LOOSE = "LOOSE",
  SLIPCASE = "SLIPCASE",
  CB_FOLD = "CB_FOLD",
  SHADOW_BOX = "SHADOW_BOX",
  FLOATING_SHADOW_BOX = "FLOATING_SHADOW_BOX",
  POLY_ONLY = "POLY_ONLY",
  TRAVEL_FRAME = "TRAVEL_FRAME",
  CRATE = "CRATE",
  SLATCRATE = "SLATCRATE",
  PALLET = "PALLET",
  COMMERCIAL_BIN = "COMMERCIAL_BIN",
  CBIN = "CBIN",
  UNKNOWN_PACKAGING = "UNKNOWN_PACKAGING",
  BOX = "BOX",
  CUSTOM = "CUSTOM",
  T_Frame = "T_Frame",
  BLANKET_WRAPPED = "BLANKET_WRAPPED",
  POLY_FOAM = "POLY_FOAM",
  POLY_FOAM_CB = "POLY_FOAM_CB",
}

export enum AddressTypes {
  RESIDENCE = "RESIDENCE",
  BUSINESS = "BUSINESS",
  HIGH_RISE = "HIGH_RISE",
  EXHIBITION = "EXHIBITION",
  INSTITUTION = "INSTITUTION",
}

export enum StaffRole {
  APPRENTICE = "APPRENTICE",
  JUNIOR = "JUNIOR",
  SENIOR = "SENIOR",
}

export enum VesselTypes {
  CARGO_VAN = "CARGO_VAN",
  SPRINTER_VAN = "SPRINTER_VAN",
  TRUCK_14 = "TRUCK_14",
  TRUCK_20 = "TRUCK_20",
  TRUCK_24 = "TRUCK_24",
  CAR = "CAR",
}

export enum OldInventoryType {
  PAINTING = "PAINTING",
  SCULPTURE = "SCULPTURE",
}

export enum InventoryMediumType {
  "0/CSV" = 0,
  "A/CVS" = 1,
  "Print" = 2,
  "Mixed Media" = 3,
  "3D work" = 4,
  "Other" = 5,
}

export enum ServiceType {
  COLLECTION = "COLLECTION",
  DELIVERY = "DELIVERY",
  WAREHOUSE_SERVICE = "WAREHOUSE_SERVICE",
  FABRICATION_SERVICE = "FABRICATION_SERVICE",
  ON_SITE_SERVICE = "ON_SITE_SERVICE",
}

export enum Urgency {
  LOW = "LOW",
  HIGH = "HIGH",
  NORMAL = "NORMAL",
  URGENT = "URGENT",
}

export enum InventoryType {
  PIECE = "PIECE",
  PACKAGE = "PACKAGE",
  PART = "PART",
}

export enum ContainerType {
  CRATE = "CRATE",
  PACKAGE = "PACKAGE",
  PIECE = "PIECE",
  T_Frame = "T_Frame",
  SLIPCASE = "SLIPCASE",
  BOX = "BOX",
  CUSTOM = "CUSTOM",
  SLATCRATE = "SLATCRATE",
  CBIN = "CBIN",
  PALLET = "PALLET",
}

export enum CheckType {
  CHECK = "CHECK",
  UNCHECK = "UNCHECK",
}

export enum ClientStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum JobStatus {
  COMPLETED = "COMPLETED",
  IN_PROGRESS = "IN-PROGRESS",
  SCHEDULED = "SCHEDULED",
  ESTIMATED = "ESTIMATED",
  CANCELLED = "CANCELLED",
  DRAFT = "DRAFT",
}

export enum SortOrder {
  ASC = "ASC",
  DESC = "DESC",
}

export enum TaskType {
  ARTWORK_HANDLING = "ARTWORK_HANDLING",
  INVENTORY = "INVENTORY",
  MAINTENANCE = "MAINTENANCE",
  MEETING = "MEETING",
  TRANSPORT = "TRANSPORT",
  OTHER = "OTHER",
}

export enum Priority {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
}

export enum TaskStatus {
  COMPLETED = "COMPLETED",
  IN_PROGRESS = "IN_PROGRESS",
  PENDING = "PENDING",
}

export enum VesselStatus {
  AVAILABLE = "AVAILABLE",
  IN_USE = "IN_USE",
  MAINTENANCE = "MAINTENANCE",
}

export enum VesselStaffRole {
  DRIVER = "DRIVER",
  LEAD = "LEAD",
}

export enum ShuttleStatus {
  SCHEDULED = "SCHEDULED",
  PLANNING = "PLANNING",
  COMPLETED = "COMPLETED",
}

export enum SuppliesType {
  TOOLS_KITS_AND_HARDWARE = "TOOLS_KITS_AND_HARDWARE",
  INTERNAL_SUPPLIES_AND_FACILITIES = "INTERNAL_SUPPLIES_AND_FACILITIES",
  PACKAGING_MATERIALS = "PACKAGING_MATERIALS",
  REFURBISHED_CRATES = "REFURBISHED_CRATES",
  PPE = "PPE",
  EQUIPMENT = "EQUIPMENT",
}

export enum RateType {
  STANDARD = "STANDARD",
  STORAGE_CLIENT = "STORAGE_CLIENT",
  VIP = "VIP",
  VENDOR = "VENDOR",
  CUSTOM = "CUSTOM",
}

export enum PaymentTerms {
  NET_15 = "NET_15",
  NET_30 = "NET_30",
  NET_45 = "NET_45",
  NET_60 = "NET_60",
  COD = "COD",
}

export enum PreferredCommunicationMethod {
  EMAIL = "EMAIL",
  TEXT_MESSAGE = "TEXT_MESSAGE",
  BOTH = "BOTH",
}

export enum TemplateType {
  CLIENT = "CLIENT",
  TEAM = "TEAM",
}

export enum StaffAvailability {
  FULL_TIME = "FULL_TIME",
  PART_TIME = "PART_TIME",
  UNAVAILABLE = "UNAVAILABLE",
}

export enum StaffStatus {
  ACTIVE = "ACTIVE",
  HIATUS = "HIATUS",
  INACTIVE = "INACTIVE",
  AVAILABLE = "AVAILABLE",
  ON_ASSIGNMENT = "ON_ASSIGNMENT",
}

export enum ActiveStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum StatusStock {
  LOW_STOCK = "LOW_STOCK",
  NOT_LOW_STOCK = "NOT_LOW_STOCK",
}

export enum Maintenance {
  IN_SERVICE = "IN_SERVICE",
  SCHEDULED = "SCHEDULED",
  COMPLETED = "COMPLETED",
}

export enum DocumentType {
  INVENTORY = "INVENTORY",
  ADMINISTRATIVE = "ADMINISTRATIVE",
  LEGAL = "LEGAL",
  SUPPLEMENTARY = "SUPPLEMENTARY",
  OTHER = "OTHER",
}

export enum DocumentStatus {
  SIGNED = "SIGNED",
  COMPLETE = "COMPLETE",
  SENT = "SENT",
}

export enum AdminChargeUnit {
  EACH = "EACH",
  HOURLY = "HOURLY",
}

export const METADATA_DEFAULT: MetaData = {
  totalItems: 0,
  itemCount: 0,
  itemsPerPage: 0,
  totalPages: 0,
  currentPage: 0,
};

export const LOCATION_PRESETS = [
  { label: "Manhattan", city: "Manhattan", state: "NY", zip: "10001" },
  { label: "Brooklyn", city: "Brooklyn", state: "NY", zip: "11201" },
  { label: "Queens", city: "Queens", state: "NY", zip: "11101" },
  { label: "Bronx", city: "Bronx", state: "NY", zip: "10451" },
  { label: "Staten Island", city: "Staten Island", state: "NY", zip: "10301" },
  { label: "Long Island City", city: "Long Island City", state: "NY", zip: "11101" },
  { label: "Jersey City", city: "Jersey City", state: "NJ", zip: "07302" },
  { label: "Hoboken", city: "Hoboken", state: "NJ", zip: "07030" },
];
